<div class="content">
    <div class="spinner" *ngIf="isSpinnerShown">
        <shared-spinner></shared-spinner>
    </div>
</div>

